<template>
  <div class="home page">
    <div class="home__title">{{$root.texts.section_prehome.title}}</div>
    <img alt="Casa Botines" @click="updateApp" src="../assets/logo_white.svg">
    <router-link
      :to="{name:'config', params:{ showBackButton: false, nextPage: 'public' }}"
      tag="button"
      class="btn-bottom"
    >{{$root.texts.section_prehome.button}}</router-link>
  </div>
</template>

<script>
export default {
  name: "home",
  methods: {
    updateApp: function() {
      window.location.reload(true);
    }
  }
};
</script>
